import { WrenchIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

export function UnderMaintenance() {
  const intl = useIntl();

  return (
    <div className="flex min-h-screen w-full flex-col">
      <div className="flex h-[90%] w-full flex-col items-center justify-center">
        <WrenchIcon size={60} alt="Maintenance" />
        <h3 className="pb-2 text-[20px] font-bold">
          {intl.formatMessage({
            defaultMessage: "App under maintenance",
            description:
              "Page title shown when the app is under scheduled maintenance",
          })}
        </h3>
        <span>
          {intl.formatMessage({
            defaultMessage: "We're making some improvements.",
            description:
              "Text on the maintenance page informing users the app is being improved",
          })}
        </span>
        <span>
          {intl.formatMessage({
            defaultMessage: "Please check back soon!",
            description:
              "Text on the maintenance page encouraging users to check back later",
          })}
        </span>
      </div>
    </div>
  );
}
